/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner } from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import get from 'lodash/get';
import TertiaryContent from '../components/tertiaryContentPage/TertiaryContent';
import * as pActions from '../actions/permit';

const propTypes = {
    router: COMPAT_ROUTER_PROP_TYPES,
    dispatch: PropTypes.func,
    id: PropTypes.string,
    name: PropTypes.string,
    additionalInformation: PropTypes.string,
};

const defaultProps = {
    additionalInformation: '',
    id: '',
    name: '',
};

export class TertiaryContentPage extends Component {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    componentDidMount() {
        const { permitId } = this.props.router.params;
        if (permitId !== this.props.id) {
            this.refetchPermit(permitId);
        }
    }

    refetchPermit(permitId) {
        this.props.dispatch(pActions.fetchPermit(permitId));
    }

    render() {
        if (!this.props.id || this.props.router.params.permitId !== this.props.id) {
            return (
                <div className="permit-loading-wrapper">
                    <Spinner />
                </div>
            );
        }
        return (
            <TertiaryContent
                id={this.props.id}
                name={this.props.name}
                additionalInformation={this.props.additionalInformation}
            />
        );
    }
}

function select(state) {
    return {
        id: get(state, 'permit.result.id'),
        name: get(state, 'permit.result.name'),
        additionalInformation: get(state, 'permit.result.description.tertiary_page'),
    };
}

export default withCompatRouter(connect(select)(TertiaryContentPage));
